module.exports = __webpack_public_path__ + "img/serengeti.4ac0172d.jpg";